export default "__VITE_ASSET__DafKNhvM__"